"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractModules = void 0;
var lodash_1 = require("lodash");
var error_handling_1 = require("../../error-handling");
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var translation_1 = __importDefault(require("../../translation"));
var variables_const_1 = require("../../variables.const");
var ContractModules = /** @class */ (function () {
    function ContractModules() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.errorHandling = object_service_1.ObjectService.getInstance(error_handling_1.ErrorHandling);
        this.numberOfModules = 0;
        this.settings = variables_const_1._settings;
        this.initialRender = true;
        this.allModules = [];
        this.idMapping = {
            // payableModules: this.settings?.modules?.refObjectPayableModules,
            modules: (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.refObjectFreeModules,
            selectableModules: (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.refObjectSelectableModules,
            selectedModules: (_f = (_e = this.settings) === null || _e === void 0 ? void 0 : _e.modules) === null || _f === void 0 ? void 0 : _f.refObjectSelectedModules,
            optionalModules: (_h = (_g = this.settings) === null || _g === void 0 ? void 0 : _g.modules) === null || _h === void 0 ? void 0 : _h.refObjectOptionalModules,
            selectedOptionalModules: (_k = (_j = this.settings) === null || _j === void 0 ? void 0 : _j.modules) === null || _k === void 0 ? void 0 : _k.refObjectSelectedOptionalModules,
        };
    }
    ContractModules.prototype.preselectModules = function () {
        var _a, _b, _c, _d, _e, _f;
        //Preselect modules by name
        if (((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.preselectModulesWithName) &&
            Array.isArray((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.preselectModulesWithName)) {
            var _loop_1 = function (key) {
                var modules = ((_e = this_1.selectedOffering) === null || _e === void 0 ? void 0 : _e[key]) || ((_f = this_1.selectedTerm) === null || _f === void 0 ? void 0 : _f[key]);
                if (modules === null || modules === void 0 ? void 0 : modules.length) {
                    var preselection_1 = this_1.settings.modules.preselectModulesWithName;
                    var _loop_2 = function () {
                        var moduleId = modules.find(function (a) { return a.name === preselection_1[i]; });
                        var moduleKey = key;
                        if (moduleId &&
                            !this_1.readData(moduleKey).some(function (a) { return a === +moduleId.id; })) {
                            this_1.addModuleId(moduleKey, +moduleId.id);
                            preselection_1.splice(i, 1);
                        }
                    };
                    for (var i = preselection_1.length - 1; i >= 0; i--) {
                        _loop_2();
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _g = ['modules', 'selectableModules', 'optionalModules']; _i < _g.length; _i++) {
                var key = _g[_i];
                _loop_1(key);
            }
        }
    };
    ContractModules.prototype.loadModule = function (settings, offerings) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.settings = settings;
                        this.findOfferingAndTerm(offerings);
                        if ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) {
                            this.settings.modules.renderModule = function (preselect) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.helper.deleteClones();
                                            if (preselect) {
                                                this.preselectModules();
                                            }
                                            return [4 /*yield*/, this.renderModule()];
                                        case 1: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); };
                        }
                        this.preselectModules();
                        return [4 /*yield*/, this.renderModule()];
                    case 1:
                        _b.sent();
                        if (this.numberOfModules === 0) {
                            console.error('NO modules in contract (modules|selectableModules|optionalModules) why you show this page?', this.selectedOffering, this.selectedTerm);
                        }
                        this.prepareEventListeners();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModules.prototype.resetModules = function () {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.refObjectSelectedModules) ||
            ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.refObjectSelectedOptionalModules)) {
            localStorage.setItem('selectableModules', '[]');
            localStorage.setItem('optionalModules', '[]');
            this.helper.deleteClones();
            this.renderModule();
        }
    };
    ContractModules.prototype.renderModule = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.allModules = [];
                        return [4 /*yield*/, this.fillModuleData('modules')];
                    case 1:
                        _f.sent();
                        return [4 /*yield*/, this.fillModuleData('selectableModules')];
                    case 2:
                        _f.sent();
                        return [4 /*yield*/, this.fillModuleData('optionalModules')];
                    case 3:
                        _f.sent();
                        if (((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.callback) && this.initialRender) {
                            this.settings.modules.callback({
                                event: 'newRender',
                                optionalModules: this.readData('optionalModules'),
                                selectableModules: this.readData('selectableModules'),
                                allModules: this.allModules,
                                selectedTerm: this.selectedTerm,
                            });
                            this.initialRender = false;
                        }
                        if (((_c = this.allModules) === null || _c === void 0 ? void 0 : _c.length) === 0 && ((_e = (_d = this.settings) === null || _d === void 0 ? void 0 : _d.redirect) === null || _e === void 0 ? void 0 : _e.length)) {
                            window.location.href = this.settings.redirect;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModules.prototype.findOfferingAndTerm = function (offerings) {
        var termId = localStorage.getItem('Memberships');
        for (var _i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
            var offering = offerings_1[_i];
            for (var _a = 0, _b = offering.terms; _a < _b.length; _a++) {
                var term = _b[_a];
                if (String(term.id) === String(termId)) {
                    this.selectedTerm = term;
                    this.selectedOffering = offering;
                    break;
                }
            }
        }
    };
    ContractModules.prototype.prepareEventListeners = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //save membership info continue with next section
                $('#Membership-Submit').on('click', function () {
                    if ((_this.selectedOffering && _this.selectedTerm) ||
                        _this.numberOfModules === 0) {
                        _this.errorHandling.hideErrorMessage();
                        localStorage.setItem('Memberships', String(_this.selectedTerm.id));
                        localStorage.setItem('contract.rateBundleTermId', String(_this.selectedTerm.id));
                        _this.redirectToContinue();
                    }
                    else {
                        _this.errorHandling.showErrorMessage(translation_1.default.t('selectContract'));
                        console.error('No Offering selected');
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    ContractModules.prototype.redirectToContinue = function () {
        var _a, _b, _c;
        if (!((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.noRedirect)) {
            window.location.href =
                (_c = this.settings.redirect) !== null && _c !== void 0 ? _c : '/membership/personliche-daten';
        }
    };
    ContractModules.prototype.fillModuleData = function (moduleKey) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var modules, key, refId, i, _loop_3, this_2, _i, modules_1, module_1, getModules, _loop_4, _k, getModules_1, modulePane, state_1;
            var _this = this;
            return __generator(this, function (_l) {
                modules = ((_a = this.selectedOffering) === null || _a === void 0 ? void 0 : _a[moduleKey]) || ((_b = this.selectedTerm) === null || _b === void 0 ? void 0 : _b[moduleKey]);
                // filter if name is in settings
                if ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.hideModulesWithName) {
                    modules = modules.filter(function (a) { return !_this.settings.modules.hideModulesWithName.includes(a.name); });
                }
                this.numberOfModules += (modules === null || modules === void 0 ? void 0 : modules.length) || 0;
                //Hide all Refobjects from id mapping
                for (key in this.idMapping) {
                    if (this.idMapping[key] && $('#' + this.idMapping[key]).length) {
                        $('#' + this.idMapping[key]).css('display', 'none');
                    }
                }
                if (modules === undefined) {
                    return [2 /*return*/];
                }
                this.allModules = __spreadArray(__spreadArray([], this.allModules, true), modules.map(function (a) { return (__assign(__assign({}, a), { type: moduleKey })); }), true);
                refId = '#' + ((_e = this.settings) === null || _e === void 0 ? void 0 : _e.refObjectId);
                if (this.idMapping[moduleKey]) {
                    refId = '#' + this.idMapping[moduleKey];
                }
                if ($(refId).length) {
                    if (variables_const_1.environment === 'dev' && (modules === null || modules === void 0 ? void 0 : modules.length) === 0) {
                        console.info("You have chosen ".concat(moduleKey, " and the refObject ").concat(refId, " exists but there are no modules for the contract defined."));
                    }
                    i = 1;
                    _loop_3 = function (module_1) {
                        //Use a different clone DOM object for selected Modules if defined in settings object
                        var dynamicRefId = refId;
                        if ((((_g = (_f = this_2.settings) === null || _f === void 0 ? void 0 : _f.modules) === null || _g === void 0 ? void 0 : _g.refObjectSelectedModules) ||
                            ((_j = (_h = this_2.settings) === null || _h === void 0 ? void 0 : _h.modules) === null || _j === void 0 ? void 0 : _j.refObjectSelectedOptionalModules)) &&
                            this_2.readData(moduleKey).some(function (a) { return a === module_1.id; })) {
                            if (moduleKey === 'selectableModules') {
                                dynamicRefId = '#' + this_2.idMapping.selectedModules;
                            }
                            if (moduleKey === 'optionalModules') {
                                dynamicRefId = '#' + this_2.idMapping.selectedOptionalModules;
                            }
                        }
                        var parent_1 = $(dynamicRefId).parent();
                        var moduleEl = this_2.helper.createClonesForRefObjectId([
                            { key: 'data-module-count', value: String(i) },
                            { key: 'data-module-key', value: moduleKey },
                            { key: 'data-contract-module', value: String(module_1.id) },
                            {
                                key: 'data-clickable',
                                value: String(moduleKey === 'selectableModules' ||
                                    moduleKey === 'optionalModules'),
                            },
                        ], dynamicRefId, true);
                        parent_1.append(moduleEl);
                        moduleEl.find('[data-get="count"]').html(String(i));
                        i++;
                    };
                    this_2 = this;
                    for (_i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
                        module_1 = modules_1[_i];
                        _loop_3(module_1);
                    }
                }
                getModules = $("[data-module-key=\"".concat(moduleKey, "\"]")).get();
                _loop_4 = function (modulePane) {
                    var addModuleButton = $(modulePane).find('[data-set="add-module-button"]').length
                        ? $(modulePane).find('[data-set="add-module-button"]')[0]
                        : modulePane;
                    if (moduleKey === 'selectableModules' ||
                        moduleKey === 'optionalModules') {
                        addModuleButton.style.cursor = 'pointer';
                        addModuleButton.addEventListener('click', function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            var moduleId = modulePane.getAttribute('data-contract-module');
                            _this.clickOnSelectableModule(+moduleId, moduleKey);
                        });
                    }
                    else {
                        addModuleButton.style.cursor = 'default';
                    }
                    var moduleId = modulePane.getAttribute('data-contract-module');
                    var module_2 = modules.find(function (a) { return String(a.id) === moduleId; });
                    if (!module_2) {
                        console.error('Module not found!', moduleId, modules.map(function (a) { return a.id; }));
                        return { value: void 0 };
                    }
                    var moduleGetters = modulePane.querySelectorAll("[data-get]");
                    moduleGetters.forEach(function (a) {
                        var _a, _b, _c, _d, _e;
                        var requested = a.getAttribute('data-get');
                        if (requested === 'imageUrl' && module_2[requested]) {
                            a.style.backgroundImage =
                                "url(" + module_2[requested] + ')';
                            a.style.backgroundSize = 'cover';
                        }
                        else if ((0, lodash_1.get)(module_2, requested) !== undefined) {
                            var text = (0, lodash_1.get)(module_2, requested);
                            if (requested === 'paymentFrequencyValue') {
                                a.innerHTML = (+text === 1 ? translation_1.default.t('per') : text);
                            }
                            else {
                                a.innerHTML = translation_1.default.t(text) + (requested === 'price' ? ' €' : '');
                            }
                        }
                        else if (variables_const_1.environment === 'dev') {
                            console.info("Your requested data [data-get]=\"".concat(requested, "\" doesn't exist on "), module_2);
                        }
                        //overwrite with settings if set
                        if ((_b = (_a = _this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.attributeOverwrites) {
                            var overwrites = (_d = (_c = _this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.attributeOverwrites;
                            if ((_e = overwrites === null || overwrites === void 0 ? void 0 : overwrites[module_2.name]) === null || _e === void 0 ? void 0 : _e[requested]) {
                                a.innerHTML = overwrites[module_2.name][requested];
                            }
                        }
                    });
                };
                for (_k = 0, getModules_1 = getModules; _k < getModules_1.length; _k++) {
                    modulePane = getModules_1[_k];
                    state_1 = _loop_4(modulePane);
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                }
                return [2 /*return*/];
            });
        });
    };
    ContractModules.prototype.clickOnSelectableModule = function (moduleId, moduleKey) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var moduleIndex = this.readData(moduleKey).findIndex(function (a) { return a === moduleId; });
        var moduleChangeEvent = {
            moduleClicked: { id: moduleId, category: moduleKey },
        };
        if (moduleIndex >= 0) {
            this.removeElementByIndex(moduleKey, moduleIndex);
            this.errorHandling.hideErrorMessage();
            moduleChangeEvent.action = 'removedFromLocalStorage';
        }
        else if (moduleKey === 'selectableModules') {
            //Different strategies to keep number of modules below the maximum
            if (this.readData(moduleKey).length <
                this.selectedOffering.maximumNumberOfSelectableModules) {
                this.addModuleId(moduleKey, moduleId);
            }
            else if ((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.errorMessageToManyModules) {
                this.errorHandling.showErrorMessage("Only ".concat(this.selectedOffering.maximumNumberOfSelectableModules, " modules are allowed per contract"));
            }
            else if ((_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.overwriteToManySelections) {
                //Simply remove last element and use the new one
                this.removeElementByIndex(moduleKey, this.readData(moduleKey).length - 1);
                this.addModuleId(moduleKey, moduleId);
            }
            moduleChangeEvent.action = 'addedToLocalStorage';
        }
        else if (moduleKey === 'optionalModules') {
            this.addModuleId(moduleKey, moduleId);
            moduleChangeEvent.action = 'addedToLocalStorage';
        }
        if ((_f = (_e = this.settings) === null || _e === void 0 ? void 0 : _e.modules) === null || _f === void 0 ? void 0 : _f.callback) {
            this.settings.modules.callback({
                event: moduleChangeEvent,
                optionalModules: this.readData('optionalModules'),
                selectableModules: this.readData('selectableModules'),
                allModules: this.allModules,
                selectedTerm: this.selectedTerm,
            });
        }
        if (((_h = (_g = this.settings) === null || _g === void 0 ? void 0 : _g.modules) === null || _h === void 0 ? void 0 : _h.refObjectSelectedModules) ||
            ((_k = (_j = this.settings) === null || _j === void 0 ? void 0 : _j.modules) === null || _k === void 0 ? void 0 : _k.refObjectSelectedOptionalModules)) {
            this.helper.deleteClones();
            this.renderModule();
        }
    };
    ContractModules.prototype.readData = function (moduleKey) {
        try {
            var data = localStorage.getItem(moduleKey);
            return data ? JSON.parse(data) : [];
        }
        catch (error) {
            console.error('Failed to parse data from localStorage:', error);
            return []; // Return an empty array if there's an error
        }
    };
    // Modify data by adding a new moduleId
    ContractModules.prototype.addModuleId = function (moduleKey, moduleId) {
        var data = this.readData(moduleKey);
        data.push(moduleId); // Modify the array
        this.writeData(moduleKey, data); // Write back the modified array to localStorage
    };
    // Write data to localStorage
    ContractModules.prototype.writeData = function (moduleKey, data) {
        try {
            localStorage.setItem(moduleKey, JSON.stringify(data));
        }
        catch (error) {
            console.error('Failed to write data to localStorage:', error);
        }
    };
    // Remove element by index from the data array and update localStorage
    ContractModules.prototype.removeElementByIndex = function (moduleKey, index) {
        var data = this.readData(moduleKey);
        if (index >= 0 && index < data.length) {
            data.splice(index, 1); // Remove the element at the specified index
            this.writeData(moduleKey, data); // Write back the modified array to localStorage
        }
        else {
            console.error('Index out of bounds');
        }
    };
    return ContractModules;
}());
exports.ContractModules = ContractModules;
